export default __webpack_public_path__ + "static/media/1249.ab10713e.png";